module.exports = __webpack_public_path__ + "static/img/taiwan_line.3a95376.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taiwan_line.png
// module id = 98
// module chunks = 1